import { useEffect, useRef, useState } from "react";

export function useComponentVisible(initialIsVisible: boolean) {
	const [isComponentVisible, setIsComponentVisible] =
		useState(initialIsVisible);
	const ref = useRef(null);

	const handleClickOutside = (event: Event) => {
		if (ref.current && !(ref.current as any).contains(event.target)) {
			setIsComponentVisible(false);
		}
	};

	useEffect(() => {
		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	});

	return { ref, isComponentVisible, setIsComponentVisible };
}

export function useIsTouchDevice() {
	const [isTouch, setIsTouch] = useState(false);

	useEffect(() => {
		const handleTouch = (event: PointerEvent) => {
			setIsTouch(event.pointerType === "touch");
		};

		window.addEventListener("pointermove", handleTouch, { passive: false });

		return () => {
			window.removeEventListener("pointermove", handleTouch);
		};
	}, []);

	return isTouch;
}
